import { Form } from "react-bootstrap";
import styled from "styled-components";

interface IProps {
  errorToDisplay: any;
}

export const Input = styled.div<IProps>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.4rem;
  margin-left: 2px;
  font-size: 12px;

  input {
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    border: ${({ errorToDisplay }) =>
      errorToDisplay
        ? "1px solid #ef4444"
        : "1px solid var(--color-input-border)"};
    border-radius: 6px;
    padding: var(--input-padding-sm);
    height: var(--input-height-sm);
    font-size: 13px;
    line-height: 1.4;
    transition: all 0.15s ease;

    &:focus {
      outline: none;
      border-color: var(--color-input-border-focus);
      box-shadow: var(--color-input-shadow);
      background-color: #fafbfc;
    }

    &:hover:not(:focus) {
      border-color: #b5bcc9;
    }

    ::placeholder {
      font-size: 12px;
      color: var(--color-input-placeholder);
      font-weight: 400;
    }
  }

  .inputMask {
    font-size: 13px;
    width: 100%;
    padding: var(--input-padding-sm);
    height: var(--input-height-sm);
    border-radius: 6px;
    transition: all 0.15s ease;
    border: ${({ errorToDisplay }) =>
      errorToDisplay
        ? "1px solid #ef4444"
        : "1px solid var(--color-input-border)"};
    line-height: 1.4;

    ::placeholder {
      font-size: 12px;
      color: var(--color-input-placeholder);
      font-weight: 400;
    }

    :focus {
      outline: none;
      border-color: var(--color-input-border-focus);
      box-shadow: var(--color-input-shadow);
      background-color: #fafbfc;
    }

    &:hover:not(:focus) {
      border-color: #b5bcc9;
    }
  }
`;

export const Wrapper = styled.div``;

export const FormInput = styled(Form.Control)`
  font-size: 13px;
  padding: var(--input-padding-sm);
  height: var(--input-height-sm);
  border-radius: 6px;
  border: 1px solid var(--color-input-border);
  transition: all 0.15s ease;
  line-height: 1.4;

  &:focus {
    outline: none;
    border-color: var(--color-input-border-focus);
    box-shadow: var(--color-input-shadow);
    background-color: #fafbfc;
  }

  &:hover:not(:focus) {
    border-color: #b5bcc9;
  }

  ::placeholder {
    font-size: 12px;
    color: var(--color-input-placeholder);
    font-weight: 400;
  }
`;

export const Error = styled.div`
  font-size: 10px;
  color: #dc2229;
  margin-top: 0.2rem;
`;
